module.exports = "/_next/static/images/waterDistributionEngineering-1328aa448cc13b68159d28918aecbb6d.webp";